let queryParams: any = {}
export default queryParams